@if (this.teams) {
  <div class="app-page">
    <table>
      <tr>
        <td>
          <img src="/assets/img/{{teams[0].SmallIconFileName}}" height="80px;"/>
        </td>
        <td>
          <h1>{{teams[0].Name}}</h1>
        </td>
      </tr>
    </table>
    <br/>
    <div  style="display: flex; flex-direction: row; flex-wrap: wrap;">
      @for (team of teams; track team) {
        <app-organization-team-card [Team]="team">
        </app-organization-team-card>
      }
    </div>
  </div>
}
